import React from "react";
import "../../App.css";
import { HeroSection } from "../index";

function Home() {
	return (
		<div>
			<HeroSection />
		</div>
	);
}

export default Home;
